/**
 * AUTO-GENERATED — do NOT edit by hand.
 * Regenerate with: node /app/scripts/generate-baseline.mjs
 * Source of truth: /app/cms/src/seed-data.ts
 * Content version: 2026.02.03-1
 */

export const CONTENT_VERSION = "2026.02.03-1";

export const SITE_SETTINGS_FALLBACK   = {
  "contentVersion": "2026.02.03-1",
  "companyName": "Manufacturing and Trading Services",
  "shortName": "MTS",
  "displayName": "Manufacturing & Trading Services",
  "tagline": "Sourcing · Manufacturing · Quality Control · International Trading",
  "descriptor": "An accountable operator between your business and the factory floor — from first specification to delivered goods.",
  "businessEmail": "",
  "supportEmail": "",
  "salesEmail": "",
  "procurementEmail": "",
  "phones": [],
  "whatsappDisplay": "+00 000 000 0000",
  "whatsappE164": "000000000",
  "addressLine1": "",
  "addressLine2": "",
  "city": "",
  "region": "",
  "postalCode": "",
  "country": "",
  "socialLinks": [
    {
      "platform": "LinkedIn",
      "url": "https://linkedin.com/",
      "handle": "linkedin.com/company/mts"
    }
  ],
  "businessHours": [],
  "copyright": "© {year} Manufacturing and Trading Services.",
  "footerLegalText": "",
  "companyRegistration": "",
  "taxId": "",
  "jurisdiction": ""
};

export const WEBSITE_CONTENT_FALLBACK = {
  "contentVersion": "2026.02.03-1",
  "homeHeroTitlePrefix": "Your execution",
  "homeHeroTitleItalic": "partner",
  "homeHeroTitleSuffix": "in Asia.",
  "homeHeroSubtitle": "Sourcing, manufacturing, quality control, and trading — executed through one accountable partner. Not a marketplace. Not a freight forwarder. An operator.",
  "homeHeroCtaLabel": "Start a Project",
  "homeWhyEyebrow": "Why choose us",
  "homeWhyTitlePrefix": "One partner. Full accountability.",
  "homeWhyTitleItalic": "Real execution.",
  "homeWhyIntro": "We are not a marketplace, a directory, or a freight forwarder. We are the operator that stands between your business and the factory floor.",
  "homeWhyBlocks": [
    {
      "icon": "Layers",
      "title": "Execution over introductions",
      "description": "We do not hand you a list of factories. We run the project end to end — from first specification to final delivery."
    },
    {
      "icon": "MapPin",
      "title": "On the ground",
      "description": "Local presence at every stage — verification, production, quality, and dispatch. Not a phone call away, a walk across the factory floor."
    },
    {
      "icon": "ScrollText",
      "title": "Transparent economics",
      "description": "You see the supplier, the specification, and the true cost. No hidden margins, no black boxes, no surprises at reconciliation."
    },
    {
      "icon": "ShieldCheck",
      "title": "Written accountability",
      "description": "Every stage is documented. Reports, sign-offs, and go / no-go decisions in writing — evidence, not assurances."
    },
    {
      "icon": "Anchor",
      "title": "Long-term partnership",
      "description": "We optimise cost, capacity, and quality across quarters — not single orders. Aligned incentives, compounding results."
    },
    {
      "icon": "Handshake",
      "title": "One counterparty",
      "description": "One contract. One point of contact. One accountable operator standing between your business and the factory floor."
    }
  ],
  "homeServicesEyebrow": "Services",
  "homeServicesTitlePrefix": "Every stage,",
  "homeServicesTitleItalic": "covered.",
  "homeServicesFeaturedSlugs": "product-sourcing,supplier-verification,manufacturing-services,production-management,quality-control,trading-services",
  "homeHowEyebrow": "How we work",
  "homeHowTitlePrefix": "A structured process,",
  "homeHowTitleItalic": "run by operators.",
  "homeHowIntro": "Six sequenced stages. No stage moves forward until the previous one is signed off — in writing.",
  "homeGovernanceTitle": "Governance model",
  "homeGovernanceItems": [
    {
      "label": "Written specifications for every stage"
    },
    {
      "label": "Explicit go / no-go decisions"
    },
    {
      "label": "Human escalation, not a queue"
    },
    {
      "label": "Response inside one business day"
    }
  ],
  "processSteps": [
    {
      "number": "01",
      "title": "Discovery",
      "body": "We understand your product, targets, constraints, and current suppliers."
    },
    {
      "number": "02",
      "title": "Sourcing & Verification",
      "body": "We identify and validate suppliers on the ground — no directories, no guesswork."
    },
    {
      "number": "03",
      "title": "Structuring",
      "body": "Commercial terms, quality specifications, and timelines agreed in writing."
    },
    {
      "number": "04",
      "title": "Execution",
      "body": "Production management, quality control, and daily coordination in your timezone."
    },
    {
      "number": "05",
      "title": "Delivery",
      "body": "Export documentation, compliance, and clean handover to your operation."
    },
    {
      "number": "06",
      "title": "Ongoing Partnership",
      "body": "Capacity expansion, new SKUs, and cost optimisation over the long term."
    }
  ],
  "homeSupportTitle": "Questions?",
  "homeSupportIntro": "Contact our team directly, or browse the knowledge base for more information.",
  "homeSupportKbLabel": "Knowledge Base",
  "homeSupportContactLabel": "Contact us",
  "homeFinalCtaTitlePrefix": "Ready to execute",
  "homeFinalCtaTitleItalic": "in Asia?",
  "homeFinalCtaBody": "Tell us about your product, goals, and timeline. We'll review your request and get back to you.",
  "homeFinalCtaLabel": "Start a Project",
  "aboutHeroEyebrow": "About MTS",
  "aboutHeroTitlePrefix": "We run projects in Asia",
  "aboutHeroTitleItalic": "so you don't have to.",
  "aboutHeroSubtitle": "MTS is an execution partner for international companies operating across Asia. We source products, verify suppliers, structure manufacturing partnerships, manage production, control quality, and execute international trading — as a single accountable operator.",
  "aboutSections": [
    {
      "tag": "Who we are",
      "heading": "Operators, not intermediaries.",
      "paragraphs": [
        {
          "text": "MTS was built by operators who spent their careers on the factory floor, in QC booths, and across negotiation tables in Asia. We are not a marketplace, a directory, or a freight forwarder. We are the operator you engage when a project has to happen — on specification, on time, and on budget."
        },
        {
          "text": "International companies work with us to enter Asia, relocate production, expand manufacturing capacity, and run structured trading operations. We hold ourselves to one standard: execution that matches what we promised in writing."
        }
      ]
    },
    {
      "tag": "How we work",
      "heading": "Sequenced, documented, accountable.",
      "paragraphs": [
        {
          "text": "Every engagement is broken into stages. Each stage has an owner, a deliverable, and a written sign-off. Nothing moves forward until the previous stage is closed."
        },
        {
          "text": "We operate in your business timezone. Escalations reach a human — not a queue. Reports are written, not verbal. Sign-off is explicit, not implied."
        }
      ]
    },
    {
      "tag": "Why trust us",
      "heading": "Evidence beats assurances.",
      "paragraphs": [
        {
          "text": "We favour written specifications over verbal agreements, independent verification over supplier self-reporting, and measurable milestones over generic timelines. Trust is earned by showing evidence at every stage — not by promising outcomes in advance."
        },
        {
          "text": "If something goes wrong, we say so first, we say so quickly, and we present options. Execution is a series of decisions under pressure; we make sure you make them with the right information."
        }
      ]
    }
  ],
  "aboutValuesEyebrow": "Values",
  "aboutValuesTitlePrefix": "Four principles we operate by,",
  "aboutValuesTitleItalic": "every day.",
  "aboutValues": [
    {
      "icon": "Target",
      "title": "Execution over promises",
      "description": "We are measured on production shipped, quality accepted, and costs held — not on decks or introductions."
    },
    {
      "icon": "Eye",
      "title": "Transparent by design",
      "description": "You see the factories, the specifications, and the true costs. No hidden margins, no black boxes."
    },
    {
      "icon": "Handshake",
      "title": "Long-term partnership",
      "description": "Our incentives are aligned with yours across quarters, not with a single order."
    },
    {
      "icon": "ClipboardCheck",
      "title": "Operational discipline",
      "description": "Documented processes, written sign-offs, and clear escalation. Every stage leaves a trail."
    }
  ],
  "aboutCtaTitlePrefix": "Let's talk about",
  "aboutCtaTitleItalic": "your project.",
  "aboutCtaLabel": "Contact Us",
  "servicesEyebrow": "Services",
  "servicesTitleItalic": "Every",
  "servicesTitleSuffix": "stage.",
  "servicesSubtitle": "A complete execution stack for companies operating across Asia — from the first specification to the final export document.",
  "servicesBottomEyebrow": "Not sure where to start?",
  "servicesBottomTitlePrefix": "Tell us the outcome.",
  "servicesBottomTitleItalic": "We'll design the path.",
  "servicesBottomBody": "Send the brief. We quote only the services you actually need — nothing bundled, nothing padded.",
  "servicesBottomCtaLabel": "Start a Project",
  "servicesCardCtaLabel": "Discuss this service",
  "servicesCardValueLabel": "Business value",
  "contactEyebrow": "Contact",
  "contactTitlePrefix": "Start a",
  "contactTitleItalic": "project.",
  "contactSubtitle": "Tell us about your product, your targets, and your timeline.",
  "contactTopics": [
    {
      "label": "Product Sourcing"
    },
    {
      "label": "Supplier Sourcing"
    },
    {
      "label": "Supplier Verification"
    },
    {
      "label": "Manufacturing Services"
    },
    {
      "label": "Production Management"
    },
    {
      "label": "Quality Control"
    },
    {
      "label": "Factory Inspection"
    },
    {
      "label": "Trading Services"
    },
    {
      "label": "Import & Export Support"
    },
    {
      "label": "Business Representation"
    },
    {
      "label": "Other"
    }
  ],
  "supportEyebrow": "Support",
  "supportTitle": "How can we help?",
  "supportSubtitle": "Ask a question. Our assistant answers only from MTS knowledge.",
  "kbArticles": [
    {
      "slug": "positioning",
      "title": "Is MTS a freight forwarder or a marketplace?",
      "excerpt": "No. MTS is an execution partner — not a marketplace, directory, freight forwarder, or logistics company."
    },
    {
      "slug": "coverage",
      "title": "What does MTS cover end to end?",
      "excerpt": "Sourcing, verification, manufacturing partnerships, production management, quality control, and international trading."
    },
    {
      "slug": "how-to-start",
      "title": "How do we start a project?",
      "excerpt": "Contact us with your product, targets, and timeline. We reply within one business day and align on the first stage."
    },
    {
      "slug": "verification",
      "title": "How is supplier verification done?",
      "excerpt": "On-site checks of legal standing, capability, quality systems, workforce, and references — reported in writing."
    },
    {
      "slug": "quality",
      "title": "How does quality control work?",
      "excerpt": "AQL-based sampling with pre-production, in-line, and pre-shipment inspections tied to your written specification."
    },
    {
      "slug": "relocation",
      "title": "Can MTS help relocate production to Asia?",
      "excerpt": "Yes. We structure supplier discovery, verification, transition planning, and initial production runs."
    }
  ],
  "quickPrompts": [
    {
      "slug": "sourcing-vs-alibaba",
      "prompt": "How is MTS different from Alibaba or a marketplace?"
    },
    {
      "slug": "verify-supplier",
      "prompt": "How do you verify a supplier before I place an order?"
    },
    {
      "slug": "qc-process",
      "prompt": "What does your quality control process cover?"
    },
    {
      "slug": "relocate-production",
      "prompt": "Can you help relocate production to Asia?"
    },
    {
      "slug": "start-project",
      "prompt": "How do we start a project together?"
    }
  ]
};

export const SERVICES_FALLBACK        = [
  {
    "slug": "product-sourcing",
    "title": "Product Sourcing",
    "icon": "PackageSearch",
    "number": "01",
    "summary": "Find the right product, at the right cost, from the right factory.",
    "value": "Reduce sourcing time and unit cost while meeting your quality and compliance targets.",
    "detail": "We translate your specification into a shortlist of qualified factories, secure quotes, run samples, and align commercial terms — before you sign anything."
  },
  {
    "slug": "supplier-sourcing",
    "title": "Supplier Sourcing",
    "icon": "Radar",
    "number": "02",
    "summary": "Identify qualified manufacturers matched to your capacity and standards.",
    "value": "Skip weeks of database searches and move directly to shortlisted, capable suppliers.",
    "detail": "Country, capacity, certifications, capability, price bracket. We narrow the field on the criteria that matter and hand you a comparable shortlist."
  },
  {
    "slug": "supplier-verification",
    "title": "Supplier Verification",
    "icon": "ShieldCheck",
    "number": "03",
    "summary": "On-the-ground checks before you commit purchase orders.",
    "value": "Eliminate the risk of paying an intermediary, a shell company, or a factory that cannot deliver.",
    "detail": "Legal standing, ownership, real production capability, quality systems, workforce, references. Verified in person, reported in writing."
  },
  {
    "slug": "manufacturing-services",
    "title": "Manufacturing Services",
    "icon": "Cog",
    "number": "04",
    "summary": "Build durable manufacturing partnerships in Asia.",
    "value": "Convert a one-off order into a stable, scalable production relationship.",
    "detail": "Structuring long-term programs, negotiating commercial terms, aligning specifications, and defining a governance model both sides respect."
  },
  {
    "slug": "production-management",
    "title": "Production Management",
    "icon": "LineChart",
    "number": "05",
    "summary": "Day-to-day oversight so your production stays on plan.",
    "value": "Fewer surprises, tighter timelines, and a single accountable point of contact.",
    "detail": "Materials, milestones, capacity, escalations. We run the production floor conversation so your team stays focused on the business."
  },
  {
    "slug": "quality-control",
    "title": "Quality Control",
    "icon": "BadgeCheck",
    "number": "06",
    "summary": "Pre-production, in-line, and pre-shipment inspections against your specification.",
    "value": "Ship what you approved. Catch deviations before they reach your customers.",
    "detail": "AQL-based sampling, defect classification, photographic reports, and clear go / no-go decisions signed off before dispatch."
  },
  {
    "slug": "factory-inspection",
    "title": "Factory Inspection",
    "icon": "ClipboardCheck",
    "number": "07",
    "summary": "Independent audits of capacity, quality systems, and compliance.",
    "value": "Objective evidence for internal committees, insurers, and buyers who need proof.",
    "detail": "Capability audits, social compliance, environmental practice, and process maturity — reported against recognised frameworks."
  },
  {
    "slug": "trading-services",
    "title": "Trading Services",
    "icon": "ArrowLeftRight",
    "number": "08",
    "summary": "Structured international trading, executed end to end.",
    "value": "One counterparty, one contract, one invoice — for cross-border transactions that would otherwise involve five.",
    "detail": "Pricing, contracts, payment terms, incoterms, settlement, documentation. Cross-border trade handled as an execution problem, not a paperwork problem."
  },
  {
    "slug": "import-export-support",
    "title": "Import & Export Support",
    "icon": "Globe2",
    "number": "09",
    "summary": "Compliance and coordination to move goods from Asia to global markets.",
    "value": "Predictable transit, correct documentation, and clean customs — every shipment.",
    "detail": "HS codes, certificates of origin, commercial invoices, packing lists, and coordination with your freight partners. We are not a freight forwarder — we are the operator that makes freight forwarders work correctly."
  },
  {
    "slug": "business-representation",
    "title": "Business Representation",
    "icon": "UsersRound",
    "number": "10",
    "summary": "Your local presence in Asia — without opening an office.",
    "value": "Same-timezone response, on-site presence, and a professional interlocutor for every partner.",
    "detail": "Meetings, negotiations, escalations, relationship management. We show up in person, in your name, on your terms."
  }
];
